import StylerModule from "./style/styler/styler";
import StyleModule from "./styleModule";

export default class VectorModule {
    style: StyleModule;
    styler: StylerModule;

    constructor() {
        this.styler = new StylerModule();
        this.style = new StyleModule(this.styler);
    }
}